import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as ManagePlanActions from 'web-app/react/plans/manage-plan/actions';
import * as PlanHelpers from 'web-app/react/entities/plans/helpers';

import * as Actions from './actions';

const EditWeekdaysState = Record({
    planPart: null,
    day: null,
    showSessions: true,
    show: false,
});

export default handleActions(
    {
        [Actions.editPlanWeekday.type]: (state, {payload}) =>
            state.merge({
                planPart: payload.planPart,
                day: payload.day,
                show: true,
            }),
        [Actions.toggleSessionsShown.type]: (state, {payload}) =>
            state.merge({
                showSessions: payload.showSessions,
            }),
        [Actions.removeSessionBooking.type]: (state, {payload}) => {
            return state.merge({
                planPart: PlanHelpers.removeSessionBookingFromPlanPart(state.planPart, payload.bookingId),
            });
        },
        [Actions.updateSessionBookingTimes.type]: (state, {payload}) => {
            return state.merge({
                planPart: PlanHelpers.updateSessionBookingOnPlanPart(state.planPart, payload.bookingId, booking =>
                    booking.merge({
                        start: payload.start,
                        end: payload.end,
                    }),
                ),
            });
        },
        [Actions.sessionBookingChanged.type]: (state, {payload}) => {
            const day = state.day;
            let planPart = state.planPart;

            const {session, bookingId, add} = payload;
            if (add) {
                planPart = PlanHelpers.addSessionToPlanPart(planPart, session, day);
            } else {
                planPart = PlanHelpers.removeSessionBookingFromPlanPart(planPart, bookingId, session, day);
            }

            return state.merge({
                planPart,
            });
        },
        [Actions.productBookingChanged.type]: (state, {payload}) => {
            const day = state.day;
            let planPart = state.planPart;

            const {product, amount} = payload;

            if (payload.amount > 0) {
                planPart = PlanHelpers.addProductToPlanPart(planPart, product, amount, day);
            } else {
                planPart = PlanHelpers.removeProductBookingFromPlanPart(planPart, product.productId, day);
            }

            return state.merge({
                planPart,
            });
        },
        [Actions.close.type]: () => new EditWeekdaysState(),
        [ManagePlanActions.closeManagePlan.type]: () => new EditWeekdaysState(),
    },
    new EditWeekdaysState(),
);
